module.exports = ".agregar-egreso{max-width:570px;max-height:586px}\n"